import React from "react";

const StoreReqItemTable = ({
    rows,
    issueMap,
    updateRow,
    inlineInput,
    STOCK_TYPE_OPTIONS,
    formatSalesValue,
    handleStockableClick,
    navigate,
    newPurchase,
    handleDeleteConfirm,
    handleDeleteRow,
    deleteLoading,
    CustomSelect,
    FiTrash2
}) => {
    return (
        <div className="bg-white rounded-md shadow-sm border border-gray-200 overflow-hidden mb-4">
            <div className="overflow-x-auto">
                <table className="w-full text-sm text-center">
                    <thead>
                        <tr className="bg-gray-50 border-b border-gray-100">
                            {["Item", "Dept", "UOM", "Qty", "Rate", "Taxable", "Stock Type", "VAT", "Total", "Issue To", "Action"].map(h => (
                                <th key={h} className="px-3 py-2.5 font-medium text-gray-500 whitespace-nowrap">{h}</th>
                            ))}
                        </tr>
                    </thead>
                    <tbody className="divide-y divide-gray-100">
                        {rows.map((item, i) => {
                            const assignments = issueMap[i] || [];
                            const isStockable = item.stocktype === "Stockable";
                            const isAssigned = assignments.length > 0;

                            return (
                                <tr key={i} className="hover:bg-gray-50/60">
                                    <td className="px-3 py-2.5 font-medium text-gray-900 whitespace-nowrap">
                                        {item.ItemName}
                                    </td>
                                    <td className="px-3 py-2.5 text-gray-500">{item.Department || '-'}</td>
                                    <td className="px-3 py-2.5 text-gray-500">{item.primary_unit || '-'}</td>

                                    <td className="px-3 py-2 w-24">
                                        <input
                                            type="number"
                                            min="0"
                                            step="any"
                                            value={item.quantity}
                                            onChange={(e) => updateRow(i, "quantity", parseFloat(e.target.value) || 0)}
                                            className={`${inlineInput}  min-w-[80px]`}
                                        />
                                    </td>

                                    <td className="px-3 py-2 w-28">
                                        <input
                                            type="number"
                                            min="0"
                                            step="any"
                                            value={item.Rate}
                                            onChange={(e) => updateRow(i, "Rate", parseFloat(e.target.value) || 0)}
                                            className={`${inlineInput}  min-w-[110px]`}
                                        />
                                    </td>

                                    <td className="px-3 py-2 text-center">
                                        <input
                                            type="checkbox"
                                            checked={item.taxable}
                                            onChange={(e) => updateRow(i, "taxable", e.target.checked)}
                                            className="h-4 w-4 text-blue-600 border-gray-300 rounded cursor-pointer"
                                        />
                                    </td>

                                    <td className="px-3 py-2 w-44">
                                        <CustomSelect
                                            options={STOCK_TYPE_OPTIONS}
                                            value={item.stocktype}
                                            placeholder="Select stock type"
                                            onChange={(val) => updateRow(i, "stocktype", val)}
                                        />
                                    </td>

                                    <td className="px-3 py-2.5 text-gray-500 whitespace-nowrap">
                                        {formatSalesValue(item.vat)}
                                    </td>

                                    <td className="px-3 py-2.5 font-medium text-gray-900 whitespace-nowrap">
                                        {formatSalesValue(item.total)}
                                    </td>

                                    <td className="px-3 py-2.5">
                                        {!isStockable ? (
                                            <button
                                                onClick={() => handleStockableClick(item, i)}
                                                className={`px-2.5 py-1 rounded-md border transition-colors whitespace-nowrap ${isAssigned
                                                    ? "border-green-200 bg-green-50 text-green-700 hover:bg-green-100"
                                                    : "border-blue-200 bg-blue-50 text-blue-700 hover:bg-blue-100"
                                                    }`}
                                            >
                                                {isAssigned
                                                    ? assignments.map(a => `${a.costCenter} (${a.qty})`).join(", ")
                                                    : "Assign →"}
                                            </button>
                                        ) : (
                                            <span className="px-2 py-1 rounded-md bg-gray-100 text-gray-600">
                                                Store
                                            </span>
                                        )}
                                    </td>

                                    <td className="px-3 py-2.5">
                                        <button
                                            onClick={() => {
                                                const isLastRow = rows.length === 1;

                                                if (isLastRow) {
                                                    handleDeleteConfirm();
                                                } else {
                                                    handleDeleteRow(i);
                                                }
                                            }}
                                            disabled={deleteLoading}
                                            className="p-2 rounded-md text-red-500 hover:text-red-700 hover:bg-red-50 transition disabled:opacity-50 disabled:cursor-not-allowed"
                                            title="Delete order"
                                        >
                                            {deleteLoading ? (
                                                <div className="w-4 h-4 border-2 border-red-500 border-t-transparent rounded-full animate-spin"></div>
                                            ) : (
                                                <FiTrash2 size={16} />
                                            )}
                                        </button>
                                    </td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default StoreReqItemTable;